export default {
 pageTitle: '离岸公司注册',
 heroDesc: '全球主流离岸地注册服务，专业团队全程协助',
 heroTag1: '50+国家和地区',
 heroTag2: '一站式服务',
 heroTag3: '专业可靠',
 countriesTitle: '热门注册地',
 countriesSubtitle: '选择最适合您业务的注册地',
 popular: '热门',
 country1Name: '香港公司注册',
 country1Feature1: '最快1天完成注册',
 country1Feature2: '税率低至16.5%',
 country1Feature3: '无外汇管制',
 country1Feature4: '国际金融中心',
 country2Name: '美国公司注册',
 country2Feature1: '全球最大市场',
 country2Feature2: '品牌价值高',
 country2Feature3: '便于融资上市',
 country2Feature4: '州别灵活选择',
 country3Name: '新加坡公司注册',
 country3Feature1: '亚洲金融枢纽',
 country3Feature2: '税收优惠政策',
 country3Feature3: '政府支持力度大',
 country3Feature4: '地理位置优越',
 country4Name: 'BVI公司注册',
 country4Feature1: '保密性极高',
 country4Feature2: '无需缴纳所得税',
 country4Feature3: '股权架构灵活',
 country4Feature4: '维护成本低',
 country5Name: '开曼公司注册',
 country5Feature1: '上市架构首选',
 country5Feature2: '零税率优势',
 country5Feature3: '国际认可度高',
 country5Feature4: '法律体系完善',
 country6Name: '英国公司注册',
 country6Feature1: '欧洲市场入口',
 country6Feature2: '品牌效应强',
 country6Feature3: '注册流程快',
 country6Feature4: '法律保障完善',
 advantagesTitle: '离岸公司的优势',
 advantagesSubtitle: '为什么选择离岸公司？',
 advantage1Title: '全球业务拓展',
 advantage1Desc: '利用离岸公司便捷开展国际贸易和投资业务',
 advantage2Title: '资产保护',
 advantage2Desc: '合理规划资产配置，有效保护企业和个人财产',
 advantage3Title: '税务优化',
 advantage3Desc: '合法利用税收优惠政策，降低企业运营成本',
 advantage4Title: '上市架构',
 advantage4Desc: '搭建标准的红筹或VIE架构，为未来上市做准备',
 processTitle: '注册流程',
 process1: '咨询沟通，确定注册地方案',
 process2: '准备相关资料和文件',
 process3: '公司名称查册和确认',
 process4: '提交注册申请',
 process5: '获取公司注册证书',
 process6: '后续配套服务（开户、税务等）',
 ctaTitle: '开始您的全球化之旅',
 ctaDesc: '我们的专业团队将为您提供最优的离岸公司注册方案',
 ctaButton: '免费咨询',
}
